module.exports = __webpack_public_path__ + "img/update.f4348d58.svg";